import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { AuthProvider } from './contexts/AuthContext.jsx';
import { App as AntApp } from 'antd';
import 'antd/dist/reset.css';
import './styles/variables.css';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AntApp>
        <App />
      </AntApp>
    </AuthProvider>
  </React.StrictMode>
); 